import { Sound as CommonSound } from "common/sound";
import * as R from "ramda";
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spriteForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "background":
            return ["background"];
        case "pleaseClick":
            return ["pleaseClick"];
    }
};
const sprite = {
    background: [0 / 30, 13 + 19 / 30],
    pleaseClick: [13 + 19 / 30, 14 + 27 / 30],
};
const spriteForHowler = R.map(([start, end]) => [
    Math.floor(start * 1000),
    Math.floor(end * 1000 - start * 1000),
], sprite);
//# sourceMappingURL=sound.js.map